import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface HUDCheckboxProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  testId: string;
  error?: boolean;
  children: React.ReactNode;
}

export function HUDCheckbox({ checked, onChange, testId, error, children }: HUDCheckboxProps) {
  return (
    <label className="group flex cursor-pointer items-start gap-3">
      <input
        type="checkbox"
        data-testid={testId}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="peer sr-only"
      />
      <motion.span
        aria-hidden
        whileTap={{ scale: 0.9 }}
        className={cn(
          "mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md border transition-[border-color,background-color,box-shadow] duration-300 peer-focus-visible:ring-2 peer-focus-visible:ring-safety/60",
          checked
            ? "border-safety bg-safety shadow-[0_0_18px_-4px_rgba(255,91,0,0.7)]"
            : error
              ? "border-red-400/70 bg-white/[0.03]"
              : "border-cad/60 bg-white/[0.03] group-hover:border-cad",
        )}
      >
        <motion.span
          initial={false}
          animate={{ scale: checked ? 1 : 0, opacity: checked ? 1 : 0 }}
          transition={{ type: "spring", stiffness: 500, damping: 26 }}
        >
          <Check size={13} strokeWidth={3} className="text-white" />
        </motion.span>
      </motion.span>
      <span className="font-sans text-sm leading-relaxed text-white/60">{children}</span>
    </label>
  );
}
